import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userReducer';
import { itemReducer } from './itemReducer';
import alertReducer from './alertSlice'; 
import OpprReducer from '../API/OpportunityServices/OpprSlice';
import GreeterReducer from '../API/Greeter/GreeterSlice';
import CustomerReducer from './ItemPage/ItempageSlice';


const store = configureStore({
    reducer: {
        user: userReducer,
        item: itemReducer,
        alert: alertReducer,
        Oppr :OpprReducer,
        greeterData:GreeterReducer,
        CustomerMaster: CustomerReducer
        // purchaseRequest: purchaseRequest
    }
});

export default store;   